import useAuth from 'hooks/useAuth';
import { useMutation, useQuery } from 'react-query';

interface Props {
  patientId?: string;
  therapistId?: string;
  status?: string;
  payload?: any;
  assignId?: string;
  preventInitialApiCall?: boolean;
}

export default function useAssignedForms({ patientId, status, therapistId, assignId, preventInitialApiCall = false }: Props) {
  const { request } = useAuth();
  const { isLoading, data, refetch } = useQuery(
    `/form-builder/forms/assign-form/patient/${patientId}`,
    () =>
      request
        .get(`/form-builder/forms/assign-form/patient/${patientId}`, {
          params: {
            status
          }
        })
        .then((response) => response.data as any),
    {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      enabled: !!patientId && !preventInitialApiCall
    }
  );
  const {
    mutateAsync: createAssignmentAsync,
    isLoading: createAssignmentIsLoading,
    mutate: createAssignment
  } = useMutation(`/form-builder/forms/assign-form/therapist/${therapistId}/patient/${patientId}`, (payload: any) => {
    return request
      .post(`/form-builder/forms/assign-form/therapist/${therapistId}/patient/${patientId}`, {
        ...payload
      })
      .then(({ data }) => data as any);
  });
  const {
    mutateAsync: updateAssignmentAsync,
    isLoading: updateAssignmentIsLoading,
    mutate: updateAssignment
  } = useMutation(`/form-builder/forms/assign-form/already-assigned/${assignId}`, (payload: any) =>
    request
      .put(`/form-builder/forms/assign-form/already-assigned/${assignId}`, {
        ...payload
      })
      .then(({ data }) => data as any)
  );

  const {
    mutateAsync: updateRefillAsync,
    isLoading: updateRefillIsLoading,
    mutate: updateRefill
  } = useMutation(`/form-builder/forms/assign-form/already-assigned/${assignId}/refill`, (payload: any) =>
    request
      .put(`/form-builder/forms/assign-form/already-assigned/${assignId}/refill`, {
        ...payload
      })
      .then(({ data }) => data as any)
  );

  const {
    isLoading: isRefillLoading,
    data: refillData,
    refetch: refetchRefill
  } = useQuery(
    `/form-builder/forms/assign-form/already-assigned/${assignId}/refill`,
    () => request.get(`/form-builder/forms/assign-form/already-assigned/${assignId}/refill`).then((response) => response.data as any),
    {
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      enabled: !!assignId
    }
  );

  return {
    isLoading,
    data,
    refetch,
    createAssignment,
    createAssignmentAsync,
    createAssignmentIsLoading,
    updateAssignmentAsync,
    updateAssignmentIsLoading,
    updateAssignment,
    updateRefill,
    updateRefillAsync,
    updateRefillIsLoading,
    isRefillLoading,
    refillData,
    refetchRefill
  };
}
